export default "__VITE_ASSET__Bz58R2pD__"